import { readNumber, readText, VAT_TAX_TYPE } from "../document-xml";
import { ITaxRow } from "./receipt-xml.models";

/** The row that carries most of the money decides how the receipt was paid. */
export const toDominantPaymentRow = (rows: Element[]): Element | undefined =>
  [...rows].sort((a, b) => readNumber(b, "SUM") - readNumber(a, "SUM"))[0];

export const toTaxRows = (rows: Element[]): ITaxRow[] =>
  rows.map(row => ({
    letter: readText(row, "LETTER"),
    rate: readNumber(row, "PRC"),
    amount: readNumber(row, "SUM"),
    isVat: readText(row, "TYPE") === VAT_TAX_TYPE,
  }));

/**
 * Line items name their taxes by letter; an empty `<LETTERS/>` means the line
 * carries none. Only the first letter is used — a line taxed twice is rare
 * enough that showing the leading rate beats showing nothing.
 */
export const toLineVatRate = ({
  letters,
  taxRows,
}: {
  letters: string;
  taxRows: ITaxRow[];
}): number | undefined => {
  const [letter] = letters.trim().split("");

  if (!letter) return undefined;

  return taxRows.find(row => row.isVat && row.letter === letter)?.rate;
};
